
// 设置token
export function setToken(tokenKey,tokenValue) {
  window.sessionStorage.setItem(tokenKey, tokenValue)
}

// 获取token
export function getToken(tokenKey) {
  return window.sessionStorage.getItem(tokenKey)
}

// 清除token
export function removeToken(tokenKey) {
  window.sessionStorage.removeItem(tokenKey)
}


